/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import "@fontsource/roboto";
import "./relatorio.css";
//import { EstabelecimentoLicenciadoexcel, RlatorioGeralEspecificoExcel } from "./gerarelatorioexcel";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// import { selecionarMeses } from '../../../../../../services/meses';
import CNPApi from '../../../../../../services/apiCNP';
import api from '../../../../../../services/api';
import { Button, TextField } from '@mui/material';
import { PictureAsPdfOutlined } from '@mui/icons-material';
import { PdfRelatorioGeral } from './pdfRelatorioGeral';
import Loading from '../../../../../../load/loading';

import { Typography, Avatar, Card } from "@mui/material";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import StatusEstabelecimento from '../../../../../../utils/status/statusEstabelecimento';
import FerramentaNavegacaoExportacao from '../../../../../../utils/paginacao';
import GraficoEstabelecimento from '../../../../../../utils/graficoEstabelecimento';
// import FerramentaNavegacaoExportacao from '../../../../../../utils/ferramentaNavegacaoExportacao';


interface Estabelecimento {
    municipio: any;
    directorTecnico: any;
    status: any;
    _id: string;
    logo: string;
    nome: string;
    createdAt: string;
    tipo: {
        createdAt: string | number | Date; designacao: string
    };
    empresa: {
        email: string;
        tel1: string;
    },
    provincia: string;
}
interface Municipio {
    designacao: any;
    provincia: {
        designacao: string;
    };
}

interface ConfigLista {
    nextPage: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    totalItems: number;
}

const prepararDadosGraficoPorMes = (dados: any[]) => {
    const meses = [
        "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
        "Jul", "Ago", "Set", "Out", "Nov", "Dez"
    ];

    const contagemPorMes = meses.map((mes, index) => ({
        mes,
        mesIndex: index,
        total: 0
    }));

    dados.forEach(item => {
        const data = new Date(item.createdAt);
        const mesIndex = data.getMonth(); // 0 a 11
        contagemPorMes[mesIndex].total += 1;
    });

    return contagemPorMes;
};

// const prepararDadosGraficoPorProvincia = (dados: any[]) => {
//     const mapa: Record<string, number> = {};

//     dados.forEach(item => {
//         const provincia = item.provincia || "Sem província";

//         if (!mapa[provincia]) {
//             mapa[provincia] = 0;
//         }

//         mapa[provincia] += 1;
//     });

//     return Object.entries(mapa).map(([provincia, total]) => ({
//         provincia,
//         total
//     }));
// };

const prepararDadosPorProvincia = (dados: any[]) => {
    const mapa: Record<string, number> = {};

    dados.forEach(item => {
        const provincia = item.provincia || "Sem província";

        mapa[provincia] = (mapa[provincia] || 0) + 1;
    });

    const totalGeral = Object.values(mapa).reduce((a, b) => a + b, 0);

    return Object.entries(mapa).map(([provincia, total]) => ({
        provincia,
        total,
        percentagem: totalGeral
            ? Number(((total / totalGeral) * 100).toFixed(1))
            : 0
    }));
};


export default function Geral() {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [esperaDados, setesperaDados] = useState(true);
    const [dados, setDados] = useState<string | undefined>('');
    const [dadosEstabelecimento, setDadosEstabelecimento] = useState<Estabelecimento[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [dadosEstabelecimentoPaginated, setDadosEstabelecimentoPaginated] = useState<Estabelecimento[]>([]);
    const [dadosEstabelecimentoTotal, setDadosEstabelecimentoTotal] = useState<Estabelecimento[]>([]);
    const [dadosEstabelecimentoSubTotal, setDadosEstabelecimentoSubTotal] = useState<Estabelecimento[]>([]);
    const [meses, setMeses] = React.useState<string | null>(null);
    const [trimestre, setTrimestre] = React.useState<number | null>(null);
    const [semestre, setSemestre] = React.useState<number | null>(null);
    const [anos, setAnos] = useState<string | undefined>('');
    const [anosFiltro, setAnosFiltro] = useState([]);
    const [provincias, setProvincias] = useState<any[]>([]);
    const [municipiosFiltrados, setMunicipiosFiltrados] = useState<Municipio[]>([]);
    const [provinciaSelecionada, setProvinciaSelecionada] = useState('');
    const [selectedTipos, setSelectedTipos] = useState([]);
    const [totalItems, settotalItems] = useState(0);
    const [tipoEstabelecimento, setTipoEstabelecimento] = useState<any[]>([]);
    const [provincia, setProvincia] = useState<string>('');
    const [selectedMunicipiosData, setSelectedMunicipiosData] = useState<Municipio[]>([]);
    const [dataInicial, setDataInicio] = useState('');
    const [dataFinal, setDataFim] = useState('');
    const [dadosGraficoMes, setDadosGraficoMes] = useState<any[]>([]);
    const [chartDataProvincia, setChartDataProvincia] = useState<any[]>([]);
    const [provinciaSelecionadaGrafico, setProvinciaSelecionadaGrafico] = useState<string | null>(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(30);
    const [configLista, setConfigLista] = useState<ConfigLista>({
        nextPage: 1,
        hasPreviousPage: false,
        hasNextPage: false,
        totalItems: 0,
    });

    useEffect(() => {
        api.get(`/estabelecimentos`).then(response => {
            settotalItems(response?.data?.totalItems ?? '');
        }).catch(error => {
        })
    }, []);


    useEffect(() => {
        setesperaDados(true);
        api.get(`/estabelecimentos?perPage=${totalItems}&provincia=${provincia}&municipio=${provinciaSelecionada}&dataInicio=${dataInicial}&dataFim=${dataFinal}&tipoId=${selectedTipos}&status=${dados}&page=${page}&perPage=${perPage}&sortBy=createdAt:ASC`)
            .then(response => {
                const anosUnicos: any = Array.from(
                    new Set(response.data.estabelecimentos.map((estabelecimento: any) =>
                        new Date(estabelecimento.createdAt).getFullYear()
                    ))
                );

                setConfigLista({
                    nextPage: response.data.nextPage || 1,
                    hasPreviousPage: response.data.hasPreviousPage || false,
                    hasNextPage: response.data.hasNextPage || false,
                    totalItems: response.data.totalItems || 0,
                });
                setAnosFiltro(anosUnicos);
                setDadosEstabelecimento(response.data.estabelecimentos || []);
                setesperaDados(false);
            })
            .catch(error => {
                setesperaDados(false);
            });
    }, [provincia, provinciaSelecionada, dados, totalItems, selectedTipos, page, perPage, dataInicial, dataFinal]);

    const anoAtual = new Date().getFullYear();
    const anoGrafico = anos ? Number(anos) : anoAtual;

    useEffect(() => {
        const dataInicio = dataInicial ? new Date(dataInicial) : null;
        const dataFim = dataFinal ? new Date(dataFinal) : null;

        const filteredData = dadosEstabelecimento.filter(dado => {
            const createdAt = new Date(dado.createdAt);

            if (anos && createdAt.getFullYear() !== Number(anos)) return false;
            if (dataInicio && createdAt < dataInicio) return false;
            if (dataFim && createdAt > dataFim) return false;

            if (
                provinciaSelecionadaGrafico &&
                dado.provincia !== provinciaSelecionadaGrafico
            ) {
                return false;
            }

            return true;
        });

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        setDadosEstabelecimentoTotal(filteredData);
        setDadosEstabelecimentoPaginated(filteredData.slice(startIndex, endIndex));

        const dadosAnoAtual = dadosEstabelecimento.filter(dado => {
            const createdAt = new Date(dado.createdAt);
            return createdAt.getFullYear() === anoGrafico;
        });

        const dadosGrafico = prepararDadosGraficoPorMes(dadosAnoAtual);
        setDadosGraficoMes(dadosGrafico);

        const dadosProvinciaAnoAtual = dadosEstabelecimento.filter(dado => {
            const createdAt = new Date(dado.createdAt);
            return createdAt.getFullYear() === anoAtual;
        });

        const dadosProvinciaOrdenados = prepararDadosPorProvincia(dadosAnoAtual)
            .sort((a, b) => b.total - a.total);

        setChartDataProvincia(dadosProvinciaOrdenados);
    }, [anos, dataInicial, dataFinal, currentPage, itemsPerPage, dadosEstabelecimento]);

    useEffect(() => {
        async function generatePdf() {
            if (dadosEstabelecimentoTotal.length > 0) {
                const pdfDocGenerator = await PdfRelatorioGeral(dadosEstabelecimentoTotal);
                pdfDocGenerator.getDataUrl((dataUrl: any) => {
                    if (iframeRef.current) {
                        iframeRef.current.src = dataUrl;
                    }
                });
            }
        }
        generatePdf();
    }, [dadosEstabelecimentoTotal]);

    // useEffect(() => {
    //     let filteredData = dadosEstabelecimentoTotal;
    //     if (meses) {
    //         filteredData = dadosEstabelecimentoTotal.filter(dado =>
    //             new Date(dado?.tipo?.createdAt).getMonth() === parseInt(meses)
    //         );
    //     }

    //     if (trimestre) {
    //         filteredData = filteredData.filter(dado => {
    //             const mes = new Date(dado?.tipo?.createdAt).getMonth() + 1;
    //             return Math.ceil(mes / 3) === trimestre;
    //         });
    //     }

    //     if (semestre) {
    //         filteredData = filteredData.filter(dado => {
    //             const mes = new Date(dado?.tipo?.createdAt).getMonth() + 1;
    //             return Math.ceil(mes / 6) === semestre;
    //         });
    //     }

    //     const startIndex = (currentPage - 1) * itemsPerPage;
    //     const endIndex = startIndex + itemsPerPage;
    //     setDadosEstabelecimentoSubTotal(filteredData);
    //     setDadosEstabelecimentoPaginated(filteredData.slice(startIndex, endIndex));

    // }, [meses, trimestre, semestre, currentPage, itemsPerPage, dadosEstabelecimentoTotal]);

    useEffect(() => {
        api.get(`/tipo-estabelecimentos/`).then(response => {
            setTipoEstabelecimento(response?.data?.tipoEstabelecimentos || []);
        }).catch(error => {
        })
    }, []);

    useEffect(() => {
        CNPApi.get(`/provincias/`).then(response => {
            setProvincias(response?.data?.provincias || []);
        }).catch(error => {
        })
    }, []);

    useEffect(() => {
        CNPApi.get(`/municipios/`).then(response => {
            //console.log(response?.data?.municipios)
            setSelectedMunicipiosData(response?.data?.municipios || []);
        }).catch(error => {
            //console.log(error)
        })
    }, []);

    useEffect(() => {
        if (provincia) {
            const filteredMunicipios = selectedMunicipiosData.filter(municipio =>
                municipio?.provincia?.designacao === provincia
            );
            setMunicipiosFiltrados(filteredMunicipios as any);
        } else {
            setMunicipiosFiltrados([]);
        }
    }, [provincia, selectedMunicipiosData]);

    // selectedTipos, dados, totalItems, anosFiltro
    const EscolheProvincias = (event: { target: { value: any } }) => {
        // console.log(event.target.value);
        setProvincia(event.target.value);
        setesperaDados(true);
        // setCurrentPage(1);
    };
    const EscolheMunicipios = (event: { target: { value: any } }) => {
        //console.log(event.target.value);

        setProvinciaSelecionada(event.target.value);
        //setesperaDados(true);
        // setCurrentPage(1);
    };
    const EscolheEstabelecimento = (event: { target: { value: any } }) => {
        // console.log(event.target.value);

        setSelectedTipos(event.target.value);
        //setesperaDados(true);
        //setCurrentPage(1);
    };
    const selecionaSTatus = (event: { target: { value: string } }) => {
        setDados(event.target.value);
        // setesperaDados(true);
        setCurrentPage(1);
        // setItemsPerPage(1);
    };

    const selecionaAno = (event: { target: { value: string } }) => {
        setAnos(event.target.value);
        //  setesperaDados(true);
        setCurrentPage(1);
    };


    const abrirPdfnoBrowser = async (dadosEstabelecimentoSubTotal: any) => {
        const pdfGerarAquivo = await PdfRelatorioGeral(dadosEstabelecimentoSubTotal);
        pdfGerarAquivo.open();
    };

    return (
        esperaDados ? <Loading text={"A carregar Dados"} focus={false} /> :
            < >
                <div style={{ height: '180px', padding: '4px', justifyContent: 'space-around', background: '#dcdede', borderRadius: '2px' }}>
                    <div style={{ width: '99%', margin: 'auto 0', }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                            <div style={{ display: "flex", alignItems: 'center', gap: '5px', marginTop: '25px' }}>
                                <FormControl sx={{ width: 120, mr: 1 }} size='small'>
                                    <InputLabel id="demo-simple-select-label">Provincias</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={provincia}
                                        label="Provincia"
                                        onChange={EscolheProvincias}
                                    >
                                        <MenuItem value={''}>Todas Provincias</MenuItem>
                                        {
                                            provincias.map((dadosprovincia, index) => (
                                                <MenuItem key={index} value={dadosprovincia?.designacao}>
                                                    <div>{dadosprovincia?.designacao}</div>
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>

                                <FormControl sx={{ m: 1, width: 120 }} size='small'>
                                    <InputLabel id="municipio-select-label">Município</InputLabel>
                                    <Select
                                        disabled={!provincia}
                                        labelId="municipio-select-label"
                                        id="municipio-select"
                                        value={provinciaSelecionada}
                                        label="Município"
                                        onChange={EscolheMunicipios}
                                    >
                                        <MenuItem value={''}>Todos Município</MenuItem>
                                        {Array.isArray(municipiosFiltrados) && municipiosFiltrados.map((municipio, index) => (
                                            <MenuItem key={index} value={municipio?.designacao}>
                                                {municipio?.designacao}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 200 }} size='small'>
                                    <InputLabel id="demo-simple-select-label">Tipo Estabelecimento</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedTipos}
                                        label="Estabelecimento"
                                        onChange={EscolheEstabelecimento}
                                    >
                                        <MenuItem value={''}>Todos Estabelecimentos</MenuItem>
                                        {
                                            Array.isArray(tipoEstabelecimento) && tipoEstabelecimento.map((meustabelecimento, index) => (
                                                <MenuItem key={index} value={meustabelecimento?._id}>
                                                    {meustabelecimento?.designacao}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                                <div>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} size='small'>
                                        <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={dados ?? undefined}
                                            label="Data"
                                            onChange={selecionaSTatus}
                                            defaultValue={''}
                                        >
                                            <MenuItem value={''}>Geral</MenuItem>
                                            <MenuItem value='Activo'>Activo</MenuItem>
                                            <MenuItem value='Reprovado'>Reprovado</MenuItem>
                                            <MenuItem value='Inspecção Agendada'>Inspecção Agendada</MenuItem>
                                            <MenuItem value='Análise'>Análise</MenuItem>
                                            <MenuItem value='Analisado'>Analisado</MenuItem>
                                            <MenuItem value='Analisado Chefe de Secção'>Analisado Chefe de Secção</MenuItem>
                                            <MenuItem value='Inspecção Realizada'>Inspecção Realizada</MenuItem>
                                            <MenuItem value='Deferimento'>Deferimento</MenuItem>
                                            <MenuItem value='Inactivo'>Inactivo</MenuItem>
                                            <MenuItem value='Por Renovar'>Por Renovar</MenuItem>
                                            <MenuItem value='Não Licenciado'>Não Licenciado</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        type="date"
                                        label="Data Inicial"
                                        name="dataInicial"
                                        variant="outlined"
                                        size='small'
                                        value={dataInicial}
                                        onChange={(e) => setDataInicio(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ m: 1 }}
                                    />
                                    <TextField
                                        type="date"
                                        label="Data Final"
                                        name="dataFinal"
                                        variant="outlined"
                                        size='small'
                                        value={dataFinal}
                                        onChange={(e) => setDataFim(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ m: 1 }}
                                    />

                                    <FormControl sx={{ m: 1, minWidth: 100 }} size='small'>
                                        <InputLabel id="demo-simple-select-label">Ano</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={anos ?? undefined}
                                            label="Data"
                                            onChange={selecionaAno}
                                            defaultValue={''}
                                        >
                                            {anosFiltro.map((ano) => (
                                                <MenuItem key={ano} value={ano}>{ano}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>

                                <Button style={{ backgroundColor: '#85287e', padding: 15 }} size='small' variant="contained" onClick={() => abrirPdfnoBrowser(dadosEstabelecimentoSubTotal)} >
                                    <PictureAsPdfOutlined sx={{ mr: 1 }} />
                                    Gerar Pdf
                                </Button>
                                {/* <Button
                                    size="small"
                                    onClick={() => setProvinciaSelecionadaGrafico(null)}
                                >
                                    limpar
                                </Button> */}

                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <div>
                        <GraficoEstabelecimento
                            chartData={dadosGraficoMes}
                            ano={anoGrafico}
                            chartDataProvincia={chartDataProvincia}
                            provinciaSelecionada={provinciaSelecionadaGrafico}
                            setProvinciaSelecionada={setProvinciaSelecionadaGrafico}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', justifyContent: 'flex-start', padding: '2px', margin: '4px 0' }}>

                        <Card variant="outlined" sx={{ width: '100%', overflow: 'hidden', maxHeight:'62vh' }} >
                            <TableContainer >
                                <Table id="myTable" size="small" stickyHeader aria-label="sticky table">
                                    <TableHead >
                                        <TableRow>
                                            {/* <TableCell ><Typography noWrap> <strong>Imagem</strong></Typography></TableCell> */}
                                            <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Tipo</strong></Typography></TableCell>
                                            {/* <TableCell ><Typography noWrap> <strong>E-mail</strong></Typography></TableCell> */}
                                            {/* <TableCell ><Typography noWrap> <strong>Telefone</strong></Typography></TableCell> */}
                                            <TableCell ><Typography noWrap> <strong>Director Técnico</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Município</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Ano</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Estado</strong></Typography></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {dadosEstabelecimentoPaginated.map((estabelecimento) => (
                                            <TableRow key={estabelecimento?._id} title={estabelecimento?.nome}>

                                                {/* <TableCell component="th" scope="row">
                                                    <Avatar variant="square" src={estabelecimento?.logo} alt={estabelecimento?.nome} />
                                                </TableCell> */}

                                                <TableCell >{estabelecimento?.nome}</TableCell>
                                                <TableCell >{estabelecimento?.tipo?.designacao ?? 'N/A'}</TableCell>
                                                {/* <TableCell >{estabelecimento?.empresa?.email ?? "####"}</TableCell> */}
                                                {/* <TableCell >{estabelecimento?.empresa?.tel1 ?? '9xxx'}</TableCell> */}
                                                <TableCell >{estabelecimento?.directorTecnico?.dadosPessoais?.nome}</TableCell>
                                                <TableCell >{estabelecimento?.provincia}</TableCell>
                                                <TableCell >{estabelecimento?.municipio}</TableCell>
                                                <TableCell >{new Date(estabelecimento?.createdAt).getFullYear()}</TableCell>
                                                <TableCell >  <StatusEstabelecimento status={estabelecimento?.status} /></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                <FerramentaNavegacaoExportacao
                                    configLista={configLista}
                                    lista={dadosEstabelecimentoSubTotal}
                                    perPage={perPage}
                                    page={page}
                                    setPage={setPage}
                                    setPerPage={setPerPage}
                                    setOrder={() => { }}
                                />

                            </TableContainer>
                        </Card>

                        <iframe
                            ref={iframeRef}
                            style={{ width: '100%', height: '90vh', border: '1px solid #ccc' }}
                            title="Gestor de Documentos"
                        />
                    </div>

                </div>
            </>

    )
}
